import ButtonsHeader from "../../components/common/ButtonsHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { inter } from "@/lib/fonts";
import { useCreateSupportRequestMutation } from "@/lib/api/apiSlice";
import { getRtkQueryErrorMessage } from "@/lib/error";
import {
  addSupportRequestInputSchema,
  IAddSupportRequestInput,
} from "muminsmart-utils";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod";
import { useNavigate } from "react-router-dom";
import { routes } from "@/lib/constants";

export default function Help() {
  const navigate = useNavigate();
  const [createSupportRequest] = useCreateSupportRequestMutation();
  const form = useForm<z.infer<typeof addSupportRequestInputSchema>>({
    resolver: zodResolver(addSupportRequestInputSchema),
    defaultValues: {
      name: "",
      email: "",
      message: "",
    },
  });

  const onSubmit = async (values: IAddSupportRequestInput) => {
    try {
      await createSupportRequest(values).unwrap();
      toast.success("Support request submitted successfully");
      form.reset();
      navigate(routes.help.pastQueries);
    } catch (error: unknown) {
      toast.error(
        getRtkQueryErrorMessage(error, "Failed to submit support request"),
      );
    }
  };

  return (
    <div className="min-h-screen">
      <ButtonsHeader heading="Help Desk" showButtons={false} />

      <div className="mt-6 min-h-screen rounded-t-3xl bg-white px-5 pb-10 pt-10">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel className="font-medium">Name</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="Query 1"
                      className="rounded-full p-5 bg-white border-[#DBDBDB]"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel className="font-medium">Email</FormLabel>
                  <FormControl>
                    <Input
                      type="email"
                      placeholder="example@gmail.com"
                      className="rounded-full p-5 bg-white border-[#DBDBDB]"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="message"
              render={({ field }) => (
                <FormItem>
                  <FormLabel className="font-medium">Message</FormLabel>
                  <FormControl>
                    <Textarea
                      placeholder="Message"
                      className="rounded-3xl p-5 bg-white border-[#DBDBDB]"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button
              type="submit"
              className={`w-full rounded-full bg-[#C18A2A] text-md font-bold text-white ${inter.className}`}
              disabled={form.formState.isSubmitting}
              aria-busy={form.formState.isSubmitting}
            >
              {form.formState.isSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </form>
        </Form>
      </div>
    </div>
  );
}
